angular.module('invoice')
    .controller('InvoiceProjectShowFullController', function ($scope, $window, $state, $stateParams, $rootScope, InvoiceProject, InvoiceProjectService, InvoiceProjectConst, Principal) {
        const BGT_TAB = 1
        const BUDGET_ANALYSIS_TAB = 2
        const BUDGET_ANALYSIS_TAB_PARAM = 'analysis'

        this.InvoiceProjectService = InvoiceProjectService
        this.Principal = Principal
        this.canReadInvoiceProjectBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_PROJECT_BGT_READ', 'ROLE_ADMIN'])
        this.canReadInvoiceProjectBudgetAnalysis = Principal.hasAnyAuthority(['ROLE_INVOICE_PROJECT_BGT_ANALYSIS_READ', 'ROLE_ADMIN'])
        this.activeBgtTab = $stateParams.tab === BUDGET_ANALYSIS_TAB_PARAM && this.canReadInvoiceProjectBudgetAnalysis ? BUDGET_ANALYSIS_TAB : (this.canReadInvoiceProjectBgt ? BGT_TAB : BUDGET_ANALYSIS_TAB)

        this.$onInit = () => {
            this.load($stateParams.id)
            // this.isAccountantOrManager = InvoiceService.isUserAccountantOrManager()
        }
        this.load = (id) => {
            InvoiceProject.get({id: id}).$promise.then(item => {
                this.item = item
                // Principal.currentUser().then(user => {
                //     this.isWorker = this.item.worker.id === user.id
                // })
            })
        }

        this.selectBgtTab = tab => {
            const tabParam = tab === BUDGET_ANALYSIS_TAB ? BUDGET_ANALYSIS_TAB_PARAM : null
            if ($stateParams.tab !== tabParam) {
                $state.go($state.current, {tab: tabParam}, {inherit: true, reload: false, notify: false, location: 'replace'})
            }
        }

        this.cancel = () => $window.history.back()
        this.canCancel = () => $window.history.length > 1

        $scope.$on(InvoiceProjectConst.eventUpdate, () => this.$onInit())
    })
